import InternalAPI from "@/app/baseAxios";

/** @borrows InternalAPI */
export default class AgentDistrictRepository extends InternalAPI {
    constructor() {
        super()
        /** @type {string} */
        this.endpoint = "/v1/network"
    }

    async findDistrict(input) {
        try {
            const res = await this.$axios.get(`${this.endpoint}/subdistrict/data?page=1&per_page=100&q=${input}`)
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data, err: null}
                }
            }
            return {data: res.data, err: null}
        } catch (err) {
            return {data: null, err: this.setErrorMessage(err.response.data.message)}
        }
    }
}
